/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTreatmentPlanVisibilityDto
 */
export interface UpdateTreatmentPlanVisibilityDto {
    /**
     * Whether the treatment plan should be hidden from the patient
     * @type {boolean}
     * @memberof UpdateTreatmentPlanVisibilityDto
     */
    isHiddenFromPatient: boolean;
}

/**
 * Check if a given object implements the UpdateTreatmentPlanVisibilityDto interface.
 */
export function instanceOfUpdateTreatmentPlanVisibilityDto(value: object): value is UpdateTreatmentPlanVisibilityDto {
    if (!('isHiddenFromPatient' in value) || value['isHiddenFromPatient'] === undefined) return false;
    return true;
}

export function UpdateTreatmentPlanVisibilityDtoFromJSON(json: any): UpdateTreatmentPlanVisibilityDto {
    return UpdateTreatmentPlanVisibilityDtoFromJSONTyped(json, false);
}

export function UpdateTreatmentPlanVisibilityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTreatmentPlanVisibilityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isHiddenFromPatient': json['isHiddenFromPatient'],
    };
}

export function UpdateTreatmentPlanVisibilityDtoToJSON(json: any): UpdateTreatmentPlanVisibilityDto {
    return UpdateTreatmentPlanVisibilityDtoToJSONTyped(json, false);
}

export function UpdateTreatmentPlanVisibilityDtoToJSONTyped(value?: UpdateTreatmentPlanVisibilityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isHiddenFromPatient': value['isHiddenFromPatient'],
    };
}

